import { doesCreditorInclude } from "components/MainSearch/Functions";
import { FilterValues } from "../Types";
import { CreditorSearchResult } from "reducers/GlobalSearch/Types";

/**
 * @function
 * @description To get the redux creditor search values filtered
 * @param creditorDetails The initial creditor search resutls - taken from Redux state
 * @param filterValues The formik input field values
 * @returns Filtered Creditor search results based on the formik input field values
 */
export const getCreditorDataFiltered = (
  creditorDetails: CreditorSearchResult[],
  filterValues: FilterValues
): CreditorSearchResult[] | [] => {
  try {
    if (Array.isArray(creditorDetails)) {
      return creditorDetails?.filter((creditorData) =>
        doesCreditorInclude(creditorData, filterValues)
      );
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
